export default __webpack_public_path__ + "static/media/login-bg.8d889c20.png";